<template>
    <section class="p-2">
      <v-card class="pb-5">
        <!-- <v-card>
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">Evolet-Maybank [ MALAYSIA BANKS ]</div>
            <div>
              <bread-crumb :bread-crumbs="['Statement Of Account']" />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
        </v-card> -->
  
        <v-card-text>
          <v-card class="pa-3" flat>
            <v-row no-gutters>
              <v-col cols="2">
                <img
                  src="../../../assets/master_logo.png"
                  alt="QQPay"
                  style="max-height: 80px; max-width: 160px"
                />
              </v-col>
              <v-col cols="6">
                <p class="font-weight-bold ma-0 pa-0">QQ Pay Sdn Bhd</p>
                <p class="ma-0 pa-0">
                  Level 20, Menara 1 Sentrum, 201, Jalan Tun Sambanthan,
                  <br />
                  Brickfields,50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
                </p>
                <a href="https://www.qqpay.my/" target="_blank">www.qqpay.io</a>
              </v-col>
              <v-col cols="4">
                  <h4>Evolet- MayBank [ MALAYSIA BANKS]</h4>
                  <div class="text-center">Statement of Account</div>
              </v-col>
            </v-row>
          </v-card>
  
          <v-data-table fixed-header  height="55vh"
            :headers="headers"
            :search="search"
            :items="vocherData"
            dense
            class="mt-5"
          >
            <template v-slot:group.header="{ group, headers, toggle, isOpen }">
              <td :colspan="headers.length">
                <div class="d-flex justify-space-between align-items-center py-2">
                  <div>
                    <v-btn @click="toggle" x-small icon :ref="group">
                      <v-icon v-if="isOpen">mdi-plus</v-icon>
                      <v-icon v-else>mdi-minus</v-icon>
                    </v-btn>
                    <span class="mx-5 font-weight-bold">{{ group }}</span>
                  </div>
                  <div>
                    <v-btn small color="primary" @click="openDialog()">Approve</v-btn>
                  </div>
                </div>
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                color="primary"
                class="mr-2"
                @click="(dialogDelete = true), (deleteId = item.id)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
          </v-data-table>
          <div>
            <div>Evolet-MayBank [ MALAYSIA BANKS]  -  Summary report : from </div>
          </div>
          <OverlayPageVue :showOverlay="loader" />
          <v-data-table fixed-header  height="55vh"
          :headers="summaryReport"
          :items="items"
          :items-per-page="5"
        ></v-data-table>
        </v-card-text>
       
      </v-card>
      <!-- <div class="text-center">
        <v-dialog persistent v-model="Statusdialog" width="500">
          <v-card>
            <v-toolbar dark color="#050048" flat dense>
              <span class="subtitleFontsize">Approve Status</span>
              <v-spacer></v-spacer>
              <v-btn depressed small icon @click="closeStatus()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="mt-2">
              <v-form v-model="valid" ref="UserListtatus">
                <v-row no-gutters class="d-block">
                  <v-col md="8">
                    <v-subheader class="required font-weight-bold pl-0 caption"
                      >Approve Status
                    </v-subheader>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-select
                      v-model="approveVoucher.status"
                      :items="statusList"
                      :rules="FieldRequired('Status')"
                      placeholder="Status"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row no-gutters class="d-block">
                  <v-col md="8">
                    <v-subheader class="required font-weight-bold pl-0 caption"
                      >Voucher Number
                    </v-subheader>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="approveVoucher.voucher_no"
                      :rules="FieldRequired('Voucher number')"
                      placeholder="Voucher Number"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
  
            <v-divider></v-divider>
  
            <v-card-actions>
              <v-btn depressed color="red" text @click="closeStatus()"> Cancel </v-btn>
              <v-btn depressed rounded color="primary" text @click="save()"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div> -->
    </section>
  </template>
  
  <script>
  import alerts from "@/mixins/alerts";
  import OverlayPageVue from "@/utils/OverlayPage.vue";
  import { FieldRequired } from "@/utils/validation.js";
  
  export default {
    name: "Voucher Not Approved",
    mixins: [alerts],
    components: {
      OverlayPageVue,
    },
  
    data: () => {
      return {
        FieldRequired,
        loader: false,
        valid: true,
        Statusdialog: false,
        search: "",
        approveVoucher: {
          status: "",
          voucher_no: null,
        },
        statusList: [
          { text: "Approve", value: "Approve" },
          { text: "Reject", value: "Reject" },
        ],
        headers: [
          { text: "Date", value: "id", sortable: false },
          { text: "Type", value: "gl_sub_head_code", sortable: false },
          { text: "Payment Mode", value: "tran_particular", sortable: false },
          { text: "NOS", value: "tran_date", sortable: false },
          { text: "Description", value: "usd_amt", sortable: false },
          { text: "DR", value: "tran_amt", sortable: false },
          { text: "CR", value: "tran_rmks", sortable: false },
          { text: "Service Fee", value: "is_active", sortable: false },
          { text: "Transfer Amt", value: "is_active", sortable: false },
          { text: "Partner Commission", value: "is_active", sortable: false },
          { text: "Ex Again", value: "is_active", sortable: false },
          { text: "Comm", value: "is_active", sortable: false },
          { text: "Settle Amt", value: "is_active", sortable: false },
          { text: "Balace", value: "is_active", sortable: false },
          { text: "CCY", value: "is_active", sortable: false },
          // { text: "Actions", value: "actions" },
        ],
        summaryReport: [
          { text: "", value: ""},
          { text: "Summary Report", value: "",  colspan: 3,sortable: false, align: 'center'},
          { text: "", value: ""},
        ],
        items:[],
        vocherData: [],
      };
    },
    computed: {},
    mounted() {
      this.getVoucherData();
    },
    methods: {
      async downloadExcelsheet() {
        if (this.vocherData) {
          this.exportToExcel(this.headers, this.vocherData, "partner Route");
        }
      },
      stoploader() {
        setTimeout(() => {
          this.loader = false;
        }, 400);
      },
    },
  };
  </script>
  <style>
  .required:after {
    content: " *";
    color: red;
  }
  </style>
  